import React, { ReactElement } from 'react';
import { connect } from 'react-redux';
import {
  sessionViewSelectors,
  setLeftPanelType,
  setShowEndSessionModal,
  setShowRenameSessionModal,
  setShowResetSessionModal,
  setShowSaveAndEndSessionModal,
} from '../../../../../../redux/views/session-view/session/slice';
import { RootState } from '../../../../../../redux/store';
import { useSessionUserContext } from '../../../../../../hooks/use-session-user-context';
import { ConnectedDCloudActionsBarCenter } from './dCloudContainer';
import { ConnectedPublicActionsBarCenter } from './publicContainer';

export function ActionsBarCenterContainer({
  setLeftPanelType,
  setShowEndSessionModal,
  setShowRenameSessionModal,
  setShowResetSessionModal,
  setShowSaveAndEndSessionModal,
  isSessionExpired,
  isSessionActiveTabTopology,
}: ActionsBarCenterContainerProps): ReactElement {
  const { accessKey, sessionUid, versionUid } = useSessionUserContext();

  if (accessKey) {
    return (
      <ConnectedPublicActionsBarCenter
        setLeftPanelType={setLeftPanelType}
        setShowEndSessionModal={setShowEndSessionModal}
        setShowRenameSessionModal={setShowRenameSessionModal}
        setShowResetSessionModal={setShowResetSessionModal}
        setShowSaveAndEndSessionModal={setShowSaveAndEndSessionModal}
        isSessionExpired={isSessionExpired}
        accessKey={accessKey}
        sessionUid={sessionUid}
        versionUid={versionUid}
        isSessionActiveTabTopology={isSessionActiveTabTopology}
      />
    );
  }

  return (
    <ConnectedDCloudActionsBarCenter
      setLeftPanelType={setLeftPanelType}
      setShowEndSessionModal={setShowEndSessionModal}
      setShowRenameSessionModal={setShowRenameSessionModal}
      setShowResetSessionModal={setShowResetSessionModal}
      setShowSaveAndEndSessionModal={setShowSaveAndEndSessionModal}
      isSessionExpired={isSessionExpired}
      sessionUid={sessionUid}
      versionUid={versionUid}
      isSessionActiveTabTopology={isSessionActiveTabTopology}
    />
  );
}

const mapDispatchToProps = {
  setLeftPanelType,
  setShowEndSessionModal,
  setShowRenameSessionModal,
  setShowResetSessionModal,
  setShowSaveAndEndSessionModal,
};

const mapStateToProps = (state: RootState) => ({
  isSessionActiveTabTopology:
    sessionViewSelectors.getSessionActiveTab(state) === 'topology',
  isSessionExpired: sessionViewSelectors.getExpired(state),
});

export type ActionsBarCenterContainerProps = ReturnType<
  typeof mapStateToProps
> &
  typeof mapDispatchToProps;

type RTKProps = {
  actions?: HalLinks;
  sessionDetails?: SessionDetails;
  isSessionDetailsLoading: boolean;
};

export type ActionsBarCenterProps = ActionsBarCenterContainerProps & RTKProps;

export const ConnectedActionsBarCenter = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ActionsBarCenterContainer);
